import React from 'react'

function Footer() {
  return (
    <footer className='footer m-2'>
      <p style={{ fontWeight: "200" }}>copyright &#169; 2024 Selva Ajeeth. All right received.</p>
    </footer>
  )
}

export default Footer